import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconMessage = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <g>
        {/* Обведення повідомлення */}
        <path
          fill={fill}
          opacity={0.3}
          d='M4 4h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8l-4 4V6c0-1.1.9-2 2-2z'
        />

        <path
          fill={fill}
          d='M7 9h10c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h7c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1z'
        />
      </g>
    </svg>
  )
}

export default IconMessage
